import {
    TableCell,
    TableRow,
} from '@mui/material';
import { getSpCount } from '../shared/utils';
export const CardTableHeader = (props) => {
    const { cards, title } = props;

    const getSPCount = (cards) => {
        let sum = 0;
        cards.forEach((card) => sum += getSpCount(card.sp_count));
        return sum;
    }

    return (
        cards.length
            ? <TableRow>
                <TableCell colSpan={12}>
                    <b>{title} ({cards.length} / {getSPCount(cards)}SP)</b>
                </TableCell>
            </TableRow>
            : null
    )
}